module.exports = __webpack_public_path__ + "img/icon_comedor.c4e71488.svg";